import React from "react";
import BaseDialog from "components/BaseDialog";
import {ConfirmActions, ConfirmBody, DangerButton, GhostButton} from "./ConfirmDialog.styles";

// Re-exported so callers compose the body with the standard emphasis styling.
export {ConfirmBody} from "./ConfirmDialog.styles";

export interface ConfirmDialogProps {
	open: boolean;
	/** Dialog heading. */
	title: string;
	/** Body content — compose with {@link ConfirmBody} for the standard copy + emphasis styling. */
	body: React.ReactNode;
	/** Ghost (dismiss) action label. */
	cancelLabel: string;
	/** Danger (proceed) action label. */
	confirmLabel: string;
	onCancel: () => void;
	onConfirm: () => void;
}

/**
 * Shared destructive-confirmation dialog (ui#283, extracted from TransferListItem so the transfers +
 * reminders rows share ONE guard): a {@link BaseDialog} with the v3 ghost/danger action pair. The
 * caller supplies localized copy and the two callbacks; the danger action styling stays here.
 */
export function ConfirmDialog({open, title, body, cancelLabel, confirmLabel, onCancel, onConfirm}: ConfirmDialogProps) {
	return (
		<BaseDialog title={title} open={open} onClose={onCancel}>
			{body}
			<ConfirmActions>
				<GhostButton type="button" onClick={onCancel}>{cancelLabel}</GhostButton>
				<DangerButton type="button" onClick={onConfirm}>{confirmLabel}</DangerButton>
			</ConfirmActions>
		</BaseDialog>
	);
}
